import React, { Dispatch } from "react";
import InformativeModal from "./InformativeModal";
import ClipboardErrorIcon from "../images/ClipboardErrorIcon";
import { Grid } from "@material-ui/core";

interface Props {
  open: boolean;
  setOpen: Dispatch<React.SetStateAction<boolean>>;
  unassign: () => void;
  numCases: number;
  loading?: boolean;
  showOnHoldWarning?: boolean;
}

export default function MultiUnassignModal({ open, setOpen, unassign, numCases, loading, showOnHoldWarning }: Props) {
  return (
    <InformativeModal
      headerText={
        <Grid container direction="column" justifyContent="space-between" alignItems="center">
          <span>
            Are you sure you want to unassign {numCases} case{numCases === 1 ? "" : "s"}?
          </span>
        </Grid>
      }
      subHeaderText={showOnHoldWarning ? "Cases that are on hold will be returned to the queue" : ""}
      icon={<ClipboardErrorIcon />}
      primaryButtonText="Proceed to unassign"
      primaryButtonTestid="proceed-to-unassign"
      primaryButtonAction={unassign}
      primaryButtonLoading={loading}
      primaryButtonDisabled={loading}
      tertiaryButtonText="Cancel"
      tertiaryButtonAction={() => setOpen(false)}
      showDivider
      open={open}
      onClose={() => setOpen(false)}
    />
  );
}
